module.exports = __webpack_public_path__ + "static/media/lease1_img2.a8437691.jpg";